export { QREditorFooter } from "./QREditorFooter";
